// removed by extract-text-webpack-plugin
module.exports = {"visible-xs":"visible-xs___JYIqx","visible-sm":"visible-sm___jzUUY","visible-md":"visible-md___20kqb","visible-lg":"visible-lg___2VySX","row":"row___3XRWR","hidden-xs":"hidden-xs___3-rFB","hidden-sm":"hidden-sm___36YBu","hidden-md":"hidden-md___3Wpqm","hidden-lg":"hidden-lg___3HdcM","main":"main___36l8K page___2ZhHk"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/BondDemoRedirect/BondDemoRedirect.css
// module id = 254
// module chunks = 0